export const LIST_LINKED_PLAYER_FAN_REQUEST = 'LIST_LINKED_PLAYER_FAN_REQUEST';
export const LIST_LINKED_PLAYER_FAN_SUCCESS = 'LIST_LINKED_PLAYER_FAN_SUCCESS';
export const LIST_LINKED_PLAYER_FAN_ERROR = 'LIST_LINKED_PLAYER_FAN_ERROR';